import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MyDataConfiguration  {
    _originalTypeClassName = "zERP.BO.MyDataConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MyDataConfiguration.translate = translateService;
}
this.Syncs = [];
this.Id = null;
this.IssuerVATNumber = null;
this.CounterpartVATNumber = null;
this.TestAadeUserId = null;
this.TestAadeKey = null;
this.EnableInvoicesAndClassificationsUpload = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IssuerVATNumber:any;
CounterpartVATNumber:any;
TestAadeUserId:any;
TestAadeKey:any;
EnableInvoicesAndClassificationsUpload:any;
Syncs:any;
static setSyncs = ($this, items) => {
                if (items == null) items = [];
                if ($this.Syncs == null) $this.Syncs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Syncs.length > 0) {
                    Domain.MyDataConfiguration.removeSyncs($this, $this.Syncs[0]);
                }

                Domain.MyDataConfiguration.addManySyncs($this, copyItems);
            }
static addManySyncs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MyDataConfiguration.addSyncs($this, items[i]);
                }
            }
static addSyncs = ($this, item) => {
                if ($this.Syncs == null) $this.Syncs = [];
                if (item == null || $this.Syncs.indexOf(item) > -1) return;
                $this.Syncs.push(item);
}
static addRangeSyncs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MyDataConfiguration.addSyncs($this, item));
            }
static removeSyncs = ($this, item) => {
                if ($this == null || $this.Syncs == null || $this.Syncs.indexOf(item) === -1) return;
                var _index = $this.Syncs.indexOf(item);
                $this.Syncs.splice(_index, 1);
}
static clearSyncs = ($this) => { $this.Syncs = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}